import React, { useEffect, useRef, useMemo } from 'react';
import { Marker, useMap } from 'react-leaflet';

import MarkerActiveIcon from 'assets/images/marker/active.svg';
import MarkerDefaultIcon from 'assets/images/marker/default.svg';
import MarkerInactiveIcon from 'assets/images/marker/inactive.svg';
import Leaflet, { LatLngTuple } from 'leaflet';

import { Container } from './styles';

interface MapMarkerInterface {
  position?: LatLngTuple;
  size?: LatLngTuple;
  isActive?: boolean;
  index?: number;
  isFromSearch?: boolean;
  changeCurrentSelected?: (index: number) => void;
}

const MapMarker: React.FC<MapMarkerInterface> = ({
  position,
  size,
  isActive,
  index,
  isFromSearch,
  changeCurrentSelected,
}) => {
  const map = useMap();

  const icon = useMemo(() => {
    if (isActive) {
      return MarkerDefaultIcon;
    }
    if (isFromSearch) {
      return MarkerActiveIcon;
    }
    return MarkerInactiveIcon;
  }, [isFromSearch, isActive]);

  useEffect(() => {
    isFromSearch && map.flyTo(position, map.getZoom());
  }, [isFromSearch, position]);

  const mapPinIcon = useMemo(
    () =>
      Leaflet.icon({
        iconUrl: icon,
        iconSize: size || [60, 60],
        iconAnchor: size ? [size[0] / 2, size[1]] : [20, 40],
        popupAnchor: size ? [0, size[1] - size[1] * 2] : [0, -40],
      }),
    [isActive],
  );

  const markerRef = useRef(null);
  useEffect(() => {
    markerRef.current.addEventListener('click', () =>
      changeCurrentSelected(index),
    );
  }, []);

  return (
    <Container>
      <Marker ref={markerRef} icon={mapPinIcon} position={position} />
    </Container>
  );
};

export default MapMarker;
